// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__dg52h","footer":"ReportModalFilter_footer__Do8ry"};